import { OfferCategory } from '../graphql/API';

export const GOOGLE_MAPS_APIKEY = process.env.REACT_APP_GOOGLE_MAP_API ?? '';

export const OFFER_RESERVATIONS_UPDATE_ERROR =
  'This offer cannot be updated because you have upcoming reservations.';

export const waitTimeOptions = [
  { value: 'Everyday', key: '0' },
  { value: '3 times per week', key: '2' },
  { value: '1 time per week', key: '6' },
  { value: '1 time every two weeks', key: '13' },
  { value: '1 time per month', key: '30' },
  { value: '1 time every 2 months', key: '60' },
  { value: '1 time per year', key: '364' },
  { value: '1 time only', key: '10000' },
];

export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;

export const OfferCategoriesConfirmWithCall = [
  OfferCategory.beauty,
  OfferCategory.boutique,
  OfferCategory.fitness,
  OfferCategory.experience,
];

export const OfferCategoriesConfirmWithCallForPremiumVenues = [
  ...OfferCategoriesConfirmWithCall,
  OfferCategory.food,
];

// export const env = "production";
export const env = process.env.REACT_APP_ENV || 'dev';
